/* eslint-disable camelcase */
import React from "react"
import { accessLevelDescription } from "utils/accessLevelHelpers"
import { auditShape } from "utils/propTypeShapes"

const AccessLevelGrantRemovedAuditItemDetails = ({ audit }) => {
  const {
    associatedType, auditedChanges, grantee, solutionName,
  } = audit
  const { access_level } = auditedChanges

  const renderAccessToObject = () => {
    if (associatedType === "Category") {
      return <span className="font-semibold">{solutionName}</span>
    }
    return ""
  }

  return (
    <div>
      <span>
        Deleted {renderAccessToObject()} {accessLevelDescription(access_level)} access level grant to <span className="font-semibold">{grantee.fullName}</span>.
      </span>
    </div>
  )
}

AccessLevelGrantRemovedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default AccessLevelGrantRemovedAuditItemDetails
